import { LatLngBounds } from 'leaflet'
import { ShapeProps, ShapeType } from '@kouto/types'
import { CircleShape, RectangleShape } from './Shape'

export const getBoundsForShape = ({
  x,
  y,
  width = 20,
  height = 10,
}: Pick<ShapeProps, 'x' | 'y' | 'width' | 'height'>): LatLngBounds =>
  new LatLngBounds([
    [y, x],
    [y + height, x + width],
  ])

export const getShapeConstructor = (type: ShapeType) => {
  switch (type) {
    case ShapeType.RECTANGLE:
      return RectangleShape
    case ShapeType.CIRCLE:
      return CircleShape
    default:
      throw new Error('unkown shape type')
  }
}

export const getImageDimensions = (
  url: string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.onload = function () {
      resolve({
        width: img.naturalWidth || img.width || 0,
        height: img.naturalHeight || img.height || 0,
      })
    }

    img.onerror = function () {
      reject(new Error(`Failed to load image's URL: ${url}`))
    }

    img.src = url
  })
}
